import { render, staticRenderFns } from "./TopicIap.vue?vue&type=template&id=24891b60&scoped=true"
import script from "./TopicIap.vue?vue&type=script&lang=js"
export * from "./TopicIap.vue?vue&type=script&lang=js"
import style0 from "./TopicIap.vue?vue&type=style&index=0&id=24891b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24891b60",
  null
  
)

export default component.exports